export const TIMER_MAX_MS = 6000;
export const TARGET_MS = 3230;
export const PLAY_COST_POINT = 8;
export const TIME_SCORE_TARGET_POINT = 3000;
export const TIME_SCORE_REWARD_POINT = 2000;
export const TIME_SCORE_NORMAL_RATE = 0.05;
export const TIME_SCORE_BOOSTER_RATE = 0.2;
export const SUCCESS_DAILY_LIMIT = 3;
export const SUCCESS_REWARD_POINT = 400;
export const CONSOLATION_REWARD_POINT = 10;
export const FREE_PLAY_DAILY_BASE = 3;
export const FREE_PLAY_COOLDOWN_MS = 30 * 1000;
export const BOOSTER_DAILY_MAX = 6;
export const BOOSTER_DURATION_MS = 30 * 1000;
export const BOOSTER_COOLDOWN_MS = 30 * 1000;
export const BOOSTER_COOLDOWN_START_THRESHOLD = 4;
export const NEAR_FAIL_DIFF_MS = 10;
export const TOAST_DURATION_MS = 2800;
export const MAX_CONSOLATION_REWARD_COUNT = 4;
export const MAX_PLAY_LOG_COUNT = 10;
export const PLAY_LOG_EXPIRE_MS = 10 * 60 * 1000;
export const DEFAULT_VISIBLE_LOG_COUNT = 5;

export const BTN_RESET_CLASS = "m-0 appearance-none border-0 bg-transparent p-0 font-['Pretendard'] focus:outline-none";

export const TIME_NYANG_GUIDE_CONTENT = {
  title: '타임냥 이용안내',
  highlights: ['정확히 3.23초에 멈추면 대박!', '찰나의 타이밍이 보상이 될 수도 있어요.'],
  sections: [
    {
      title: '1. 타임냥',
      items: [
        '1회 플레이당 8포인트 차감',
        '3.23초 정확히 달성 시 400P 보상 (광고 시청)',
        '하루 최대 3회 성공 보상 가능',
        '6초 경과 시 자동 정지',
      ],
    },
    {
      title: '2. 위로 보상 (0.01초 차이)',
      items: ['3.22초 또는 3.24초 달성 시', '10P 보상 × 3회 (광고 시청)', '4회차 달성 시 무료탐냥 횟수 +1'],
    },
    {
      title: '3. 무료탐냥',
      items: ['광고 시청 후 무료 1회 (6초 제한)', '매일 00:00에 3회 충전', '매회차 쿨타임 30초'],
    },
    {
      title: '4. 적립부스터',
      items: [
        '30초간 진행',
        '적립률 5% → 20% (×4)',
        '필수/무료탐냥 광고 스킵 (성공/위로 보상 광고는 일시정지 후 재생)',
        '매일 00:00에 6회 충전',
        '4회차부터 쿨타임 30초',
      ],
    },
    {
      title: '5. 타임스코어',
      items: ['플레이 시 자동 적립', '3,000P 달성 시 N Pay 2천 원권 교환'],
    },
  ],
  notices: [
    '일일 카운터는 매일 00:00에 리셋됩니다.',
    '보상 지급은 운영 상황에 따라 별도의 안내 없이 변경 또는 중단될 수 있습니다.',
  ],
};
